<ul *ngIf="isExpanded; else selectedOnly" class="sliding-list">
  <li *ngFor="let option of options; let first=first" class="sliding-list-item">
    <a class="sliding-list-item-link" [class.mod-first]="first" (click)="select(option)">
      {{getDisplayedLanguage(option) | translate}}
    </a>
  </li>
</ul>

<ng-template #selectedOnly>
  <a class="sliding-list-item-link branding-accent-normal-border branding-accent-normal-foreground mod-single" (click)="open()">{{getDisplayedLanguage(selected) | translate}}</a>
</ng-template>
